import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { delay } from 'rxjs/operators';

export interface BreadcrumbItem {
  label: string;
  icon?: string; // svg path string
  action?: () => void;
}

@Injectable({ providedIn: 'root' })
export class BreadcrumbService {
  private itemsSubject = new BehaviorSubject<BreadcrumbItem[]>([]);
  items$ = this.itemsSubject.asObservable().pipe(delay(0));

  set(items: BreadcrumbItem[]): void {
    this.itemsSubject.next(items);
  }

  clear(): void {
    this.itemsSubject.next([]);
  }
}
